(() => {
  const ROOT_SELECTOR =
    '#main-cart .docapp-free-gift-progress, .cart__blocks .docapp-free-gift-progress, #CartDrawer .docapp-free-gift-progress, cart-drawer .docapp-free-gift-progress';
  const PAGE_WIDGET_SELECTOR = '#main-cart .docapp-free-gift-progress';
  const MOBILE_QUERY = '(max-width: 989.98px)';

  let scheduled = false;
  let mediaQuery;

  const normalizeProgress = (root) => {
    if (!(root instanceof HTMLElement)) return;

    const container = root.querySelector('.docapp-fg-progress-container');
    if (container instanceof HTMLElement) {
      container.style.setProperty('padding-top', '24px', 'important');
      container.style.setProperty('padding-right', '12px', 'important');
      container.style.setProperty('padding-bottom', '10px', 'important');
      container.style.setProperty('padding-left', '12px', 'important');
    }

    const label = root.querySelector('.docapp-fg-progress-label');
    if (label instanceof HTMLElement && !label.textContent.trim()) {
      const nextLabel = root.querySelector(
        '.docapp-fg-progress-goal.docapp-fg-goal-next .docapp-fg-pin-label'
      );
      if (nextLabel instanceof HTMLElement && nextLabel.innerHTML.trim()) {
        label.innerHTML = nextLabel.innerHTML;
      }
    }
  };

  const getPageWidget = () => {
    const widgets = [...document.querySelectorAll(PAGE_WIDGET_SELECTOR)];
    if (!widgets.length) return null;

    const filled = widgets.find((widget) => widget.querySelector('.docapp-fg-progress-track'));
    const keep = filled || widgets[0];

    widgets.forEach((widget) => {
      if (widget !== keep) widget.remove();
    });

    return keep;
  };

  const placePageWidget = () => {
    const widget = getPageWidget();
    if (!widget) return;

    const isMobile = mediaQuery?.matches ?? window.matchMedia(MOBILE_QUERY).matches;
    const targetSlot = document.querySelector(
      isMobile ? '[data-docapp-fg-slot="mobile"]' : '[data-docapp-fg-slot="desktop"]'
    );

    if (!(targetSlot instanceof HTMLElement)) return;
    if (widget.parentElement === targetSlot) return;

    targetSlot.appendChild(widget);
  };

  const normalizeAll = () => {
    placePageWidget();
    document.querySelectorAll(ROOT_SELECTOR).forEach(normalizeProgress);
  };

  const scheduleNormalize = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      normalizeAll();
    });
  };

  const observe = () => {
    mediaQuery = window.matchMedia(MOBILE_QUERY);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', scheduleNormalize);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(scheduleNormalize);
    }

    normalizeAll();

    const observer = new MutationObserver(scheduleNormalize);
    const targets = [
      document.querySelector('#main-cart'),
      document.querySelector('#CartDrawer'),
      document.querySelector('#cart-summary'),
      document.querySelector('.cart__blocks'),
    ].filter(Boolean);

    if (!targets.length) {
      observer.observe(document.documentElement, { childList: true, subtree: true });
      return;
    }

    targets.forEach((target) => {
      observer.observe(target, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
